<template>
  <div class="experience">
    <div class="box">
      <h5>Model</h5>
      <el-select
        v-model="modelValue"
        placeholder="请选择"
        size="mini"
        style="width: 100%"
        @change="modelFun"
      >
        <el-option
          v-for="item in options"
          :key="item._id"
          :label="item.title"
          :value="item._id"
        >
        </el-option>
      </el-select>
    </div>
    <!-- <div class="box" style="margin-bottom: 25px">
      <h5>
        System Prompt
        <el-tooltip
          class="item"
          effect="dark"
          content="Describe system prompt here"
          placement="top-start"
        >
          <el-icon
            class="el-icon-warning-outline"
             style="margin-left: 2px"
          ></el-icon>
        </el-tooltip>
      </h5>
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入内容"
        v-model="textarea"
      >
      </el-input>
    </div> -->
    <div class="box">
      <div style="display: flex; justify-content: space-between">
        <h5>Max Tokens</h5>
        <el-input
          v-model="tokensValue"
          style="width: 60px"
          size="mini"
          :min="1"
          :max="1648"
          :step="1"
          type="number"
          @change="tokensFun"
        ></el-input>
      </div>
      <el-slider
        v-model="tokensValue"
        size="mini"
        :min="1"
        :max="1648"
           :step="1"
        @change="tokensFun"
      ></el-slider>
    </div>
    <div class="box">
      <div style="display: flex; justify-content: space-between">
        <h5>
          Temperature
          <el-tooltip
            class="item"
            effect="dark"
            content="Controls the randomness of the model’s output. Higher values (closer to 1) make output more random, while lower values make the output more deterministic."
            placement="top-start"
          >
            <el-icon
              class="el-icon-warning-outline"
              style="margin-left: 2px"
            ></el-icon>
          </el-tooltip>
        </h5>
        <el-input
          v-model="TemperatureValue"
          style="width: 60px"
          size="mini"
          :min="0.0"
          :max="2.0"
          :step="0.1"
          type="number"
          @change="TemperatureFun"
        ></el-input>
      </div>
      <el-slider
        v-model="TemperatureValue"
        size="mini"
        :min="0.0"
        :max="2.0"
           :step="0.1"
        @change="TemperatureFun"
      ></el-slider>
    </div>
    <div class="box">
      <div style="display: flex; justify-content: space-between">
        <h5>
          Top-P
          <el-tooltip
            class="item"
            effect="dark"
            content="Specifies the diversity of the model’s output. Similar to temperature but more precise."
            placement="top-start"
          >
            <el-icon
              class="el-icon-warning-outline"
              style="margin-left: 2px"
            ></el-icon>
          </el-tooltip>
        </h5>
        <el-input
          v-model="TopValue"
          style="width: 60px"
          size="mini"
          :min="0.1"
          :max="1.0"
          :step="0.1"
          type="number"
          @change="topFun"
        ></el-input>
      </div>
      <el-slider
        v-model="TopValue"
        size="mini"
        :min="0.1"
        :max="1.0"
           :step="0.1"
        @change="topFun"
      ></el-slider>
    </div>
    <!-- <div class="box">
      <div style="display: flex; justify-content: space-between">
        <h5>
          Top-K

          <el-tooltip
            class="item"
            effect="dark"
            content="Specifies the diversity of the model’s output. Similar to temperature but more precise."
            placement="top-start"
          >
            <el-icon
              class="el-icon-warning-outline"
           style="margin-left: 2px"
            ></el-icon>
          </el-tooltip>
        </h5>
        <el-input
          v-model="TopkValue"
          style="width: 60px"
          size="mini"
            :min="0"
          :step="1"
          type="number"
        ></el-input>
      </div>
      <el-slider v-model="TopkValue" size="mini"></el-slider>
    </div> -->
    <div class="box">
      <div style="display: flex; justify-content: space-between">
        <h5>
          Frequency Penalty

          <el-tooltip
            class="item"
            effect="dark"
            content="Specifies the diversity of the model’s output. Similar to temperature but more precise."
            placement="top-start"
          >
            <el-icon
              class="el-icon-warning-outline"
              style="margin-left: 2px"
            ></el-icon>
          </el-tooltip>
        </h5>
        <el-input
          v-model="PenaltyValue"
          style="width: 60px"
          size="mini"
          :min="-2.0"
          :max="2.0"
          :step="0.1"
          type="number"
          @change="PenaltyFun"
        ></el-input>
      </div>
      <el-slider
        v-model="PenaltyValue"
        size="mini"
        :min="-2.0"
        :max="2.0"
           :step="0.1"
        @change="PenaltyFun"
      ></el-slider>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      modelValue: "",
      modelName: "",
      tokensValue: 1024,
      TemperatureValue: 0.8,
      TopValue: 0.7,
      TopkValue: 51,
      PenaltyValue: 0.0,
      form: {},
      textarea: "",
      options: [],
    };
  },
  mounted() {
    this.modelList();
  },
  methods: {
    modelFun(e) {
      console.log(e);
      this.options.forEach((item, index) => {
        if (e == item._id) {
          this.modelName = item.title;
          let value = {
            model_id: this.modelValue,
            model_name: this.modelName,
            // content: "文本对话",
            max_tokens: this.tokensValue,
            temperature: this.TemperatureValue,
            top_p: this.TopValue,
            frequency_penalty: this.PenaltyValue,
          };
          this.$emit("modelFun", JSON.stringify(value));
        }
      });
    },
    tokensFun() {
      let value = {
        model_id: this.modelValue,
        model_name: this.modelName,
        // content: "文本对话",
        max_tokens: this.tokensValue,
        temperature: this.TemperatureValue,
        top_p: this.TopValue,
        frequency_penalty: this.PenaltyValue,
      };
      this.$emit("modelFun", JSON.stringify(value));
    },
    TemperatureFun() {
      let value = {
        model_id: this.modelValue,
        model_name: this.modelName,
        // content: "文本对话",
        max_tokens: this.tokensValue,
        temperature: this.TemperatureValue,
        top_p: this.TopValue,
        frequency_penalty: this.PenaltyValue,
      };
      this.$emit("modelFun", JSON.stringify(value));
    },
    topFun() {
      let value = {
        model_id: this.modelValue,
        model_name: this.modelName,
        // content: "文本对话",
        max_tokens: this.tokensValue,
        temperature: this.TemperatureValue,
        top_p: this.TopValue,
        frequency_penalty: this.PenaltyValue,
      };
      this.$emit("modelFun", JSON.stringify(value));
    },
    PenaltyFun() {
      let value = {
        model_id: this.modelValue,
        model_name: this.modelName,
        // content: "文本对话",
        max_tokens: this.tokensValue,
        temperature: this.TemperatureValue,
        top_p: this.TopValue,
        frequency_penalty: this.PenaltyValue,
      };
      this.$emit("modelFun", JSON.stringify(value));
    },
    modelList() {
      let data = {
        op: "model_list",
        type:window.localStorage.getItem('anjign-wbzx')//"文本对话",
      };
      //model_search  app_search  key_search
      let _this = this;
      this.$axios
        .post("/index.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            _this.options = response.data.data;
            // _this.modelValue = _this.options[0]._id;
            // _this.modelName = _this.options[0].title;
            _this.options.forEach((item, index) => {
              if(window.localStorage.getItem('anjign-wbzx-model') == item.title){
                _this.modelValue = item._id;
                 _this.modelName = item.title;
              }
            });
           // window.localStorage.setItem('anjign-wbzx-model',obj.title)
            // _this.$emit('modelFun',_this.modelName)
            let value = {
              model_id: _this.modelValue,
              model_name: _this.modelName,
              // content: "文本对话",
              max_tokens: _this.tokensValue,
              temperature: _this.TemperatureValue,
              top_p: _this.TopValue,
              frequency_penalty: _this.PenaltyValue,
            };
            _this.$emit("modelFun", JSON.stringify(value));
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.experience /deep/.el-input__inner {
  border-radius: 5px;
  padding-right: 0;
  padding-left: 3px;
}
.experience /deep/.el-form-item__label {
  height: 28px;
  font-weight: bold;
}
.experience /deep/.el-form-item {
  margin-bottom: 0;
}
.box {
  margin-bottom: 30px;
}
h5 {
  margin: 0;
  margin-bottom: 10px;
}
/deep/.el-slider__bar {
  background: #7c3aed;
}
/deep/.el-slider__button {
  border: 2px solid #7c3aed;
}
/deep/.el-slider__runway {
  margin-top: 10px;
}
</style>